import { render } from "./Food.vue?vue&type=template&id=164180f0"
import script from "./Food.vue?vue&type=script&lang=js"
export * from "./Food.vue?vue&type=script&lang=js"

import exportComponent from "F:\\App-themes\\clickon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__